import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: '[app-helipad]',
    templateUrl: './helipad.component.html',
    styleUrl: './helipad.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class HelipadComponent {

}
